import { useEffect } from "react";

export default function useClickOutside(ref, handler) {
  useEffect(() => {
    function listener(e) {
      // Do nothing if clicking inside the element
      if (!ref.current || ref.current.contains(e.target)) return;
      handler();
    }

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}
